/**
 * 门禁码验证弹窗状态管理
 * 使用模块级变量，简单高效，不影响其他组件
 */

// 标记是否应该检查待验证码（从AccessInfoDetailPage返回时设置）
let shouldCheckPendingCodes = false;

export const setShouldCheckPendingCodes = (value: boolean) => {
    shouldCheckPendingCodes = value;
};

export const getAndClearShouldCheckPendingCodes = (): boolean => {
    const result = shouldCheckPendingCodes;
    shouldCheckPendingCodes = false;
    return result;
};

